module.exports = __webpack_public_path__ + "img/pukepai.a703bcc3.gif";